import { render, staticRenderFns } from "./UmsTenantHistory.vue?vue&type=template&id=274ef89b&"
import script from "./UmsTenantHistory.vue?vue&type=script&lang=js&"
export * from "./UmsTenantHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports